import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { NAV, SETTINGS_NAV } from '../nav';
import { LOGO_URL } from '../ui';

const NavItem = ({ item, view, go, open, toggle }) => {
  const Icon = item.icon;
  const top = view.split('/')[0];
  const active = top === item.key;
  const hasKids = Array.isArray(item.children) && item.children.length > 0;
  const onClick = () => {
    if (hasKids) toggle(item.key);
    if (item.soon) go(`soon/${item.key}`);
    else go(hasKids && typeof item.children[0] !== 'string' ? item.children[0].key : item.key);
  };
  return (
    <div>
      <button type="button" onClick={onClick} className={`erp-nav-item ${active ? 'active' : ''}`} data-testid={`nav-${item.key}`}>
        <Icon size={18} strokeWidth={1.9} />
        <span className="flex-1 truncate">{item.label}</span>
        {hasKids && <ChevronRight size={15} className={`transition-transform duration-200 ${open ? 'rotate-90' : ''}`} style={{ opacity: .6 }} />}
      </button>
      {hasKids && open && (
        <div className="mt-0.5 mb-1 space-y-0.5">
          {item.children.map((c) => {
            const child = typeof c === 'string' ? { key: `soon/${item.key}/${c}`, label: c } : c;
            return (
              <button key={child.key} type="button" onClick={() => go(child.key)} data-testid={`nav-${child.key.replace(/[\s/]/g, '-').toLowerCase()}`}
                className={`erp-nav-sub ${view === child.key ? 'active' : ''}`}>{child.label}</button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const Sidebar = ({ view, go, collapsed }) => {
  const [openKeys, setOpenKeys] = useState(() => new Set([view.split('/')[0]]));
  const toggle = (k) => setOpenKeys((s) => { const n = new Set(s); n.has(k) ? n.delete(k) : n.add(k); return n; });

  return (
    <aside data-testid="erp-sidebar"
      className={`flex-shrink-0 h-screen sticky top-0 flex flex-col text-white transition-[width] duration-300 ${collapsed ? 'w-0 overflow-hidden' : 'w-[248px]'}`}
      style={{ background: 'var(--erp-navy)' }}>
      <div className="p-4">
        <button type="button" onClick={() => go('dashboard')} className="w-full bg-white rounded-xl p-3 shadow-md grid place-items-center" data-testid="erp-logo">
          <img src={LOGO_URL} alt="Namoh Toolings" className="h-[88px] object-contain" />
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto erp-scroll erp-scroll-dark px-3 pb-3 space-y-0.5">
        {NAV.map((n) => <NavItem key={n.key} item={n} view={view} go={go} open={openKeys.has(n.key)} toggle={toggle} />)}
      </nav>
      <div className="px-3 py-3 border-t" style={{ borderColor: 'rgba(255,255,255,.1)' }}>
        <NavItem item={SETTINGS_NAV} view={view} go={go} open={false} toggle={() => {}} />
      </div>
    </aside>
  );
};
